import { UserProfile } from '@/services/ProfileService';

export interface User {
  id: string;
  email: string;
  name?: string;
  profile?: UserProfile | null;
  isAdmin?: boolean;
}

export interface AuthContextType {
  user: User | null;
  isAuthenticated?: boolean;
  isLoading: boolean;
  isAdmin: boolean;
  devModeEnabled: boolean;
  toggleDevMode: () => void;
  logOut: () => Promise<boolean>;
  login?: (email: string, remember: boolean) => Promise<void>;
  loginWithGoogle?: (remember: boolean) => Promise<void>;
  logout?: () => void;
}

export const actionCodeSettings = {
  url: window.location.href.includes('localhost') 
    ? 'http://localhost:8080/confirm-login'
    : `${window.location.origin}/confirm-login`,
  handleCodeInApp: true
};
